var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M25 1C11.745 1 1 11.745 1 25s10.745 24 24 24 24-10.745 24-24S38.255 1 25 1zm8.295 25.272l-12 7.5A1.5 1.5 0 0 1 19 32.5v-15a1.5 1.5 0 0 1 2.295-1.272l12 7.5a1.502 1.502 0 0 1 0 2.544zM25 1C11.745 1 1 11.745 1 25s10.745 24 24 24 24-10.745 24-24S38.255 1 25 1zm8.295 25.272l-12 7.5A1.5 1.5 0 0 1 19 32.5v-15a1.5 1.5 0 0 1 2.295-1.272l12 7.5a1.502 1.502 0 0 1 0 2.544zM25 1C11.745 1 1 11.745 1 25s10.745 24 24 24 24-10.745 24-24S38.255 1 25 1zm8.295 25.272l-12 7.5A1.5 1.5 0 0 1 19 32.5v-15a1.5 1.5 0 0 1 2.295-1.272l12 7.5a1.502 1.502 0 0 1 0 2.544z",
    opacity: 0.605
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    d: "M25 .5C38.53.5 49.5 11.47 49.5 25S38.53 49.5 25 49.5.5 38.53.5 25 11.47.5 25 .5zm8.03 25.348a1.002 1.002 0 0 0 0-1.696l-12-7.5a1 1 0 1 0-1.53.848v15a1 1 0 0 0 1.53.848l12-7.5zM25 .5C38.53.5 49.5 11.47 49.5 25S38.53 49.5 25 49.5.5 38.53.5 25 11.47.5 25 .5zm8.03 25.348a1.002 1.002 0 0 0 0-1.696l-12-7.5a1 1 0 1 0-1.53.848v15a1 1 0 0 0 1.53.848l12-7.5zM25 .5C38.53.5 49.5 11.47 49.5 25S38.53 49.5 25 49.5.5 38.53.5 25 11.47.5 25 .5zm8.03 25.348a1.002 1.002 0 0 0 0-1.696l-12-7.5a1 1 0 1 0-1.53.848v15a1 1 0 0 0 1.53.848l12-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M33.295 26.273l-12 7.5A1.5 1.5 0 0 1 19 32.5v-15a1.5 1.5 0 0 1 2.295-1.272l12 7.5a1.502 1.502 0 0 1 0 2.544z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.e98464a4.svg";
export { ForwardRef as ReactComponent };